import { render, staticRenderFns } from "./FormaDataBase.vue?vue&type=template&id=f5049d3e&scoped=true&"
import script from "./FormaDataBase.vue?vue&type=script&lang=js&"
export * from "./FormaDataBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5049d3e",
  null
  
)

export default component.exports